import React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { colors } from '@mui/material';
import PropTypes from 'prop-types';
import DownloadIcon from '@mui/icons-material/Download';
import { Link } from 'gatsby';
import moment from 'moment';
import MuiLink from '@mui/material/Link';
const Versions = ({currentData,platform}) => {
  return (
    <Box>
      <Box marginBottom={2}>
        <Box marginBottom={2} display={'flex'} alignItems={'center'}>
          <Box
            component={Avatar}
						bgcolor={currentData.color[100]}
						color={currentData.color[900]}
            marginBottom={1}
            width={60}
            height={60}
          >
            {currentData.icon}
          </Box>
          <Box marginLeft={2}>
            <Typography variant={'h6'} fontWeight={700} gutterBottom>
              {currentData.title}
            </Typography>
            <Typography color={'text.secondary'}>
              Pipy {currentData.version} (latest) Updated {moment(currentData.lastModified).fromNow()}
            </Typography>
          </Box>
        </Box>
				{currentData.links.map((item, i) => (
				<Box component={'a'} href={item.href} target="_blank"
					paddingY={1 / 2}
					paddingX={1}
					bgcolor={'secondary.main'}
					borderRadius={2}
					style={{'marginRight':'10px'}}
					marginTop={2}
				>
				  <DownloadIcon sx={{ color: 'common.black',fontSize:'1.1em',position:'relative',marginRight:'2px',top:3 }}/>
					<Typography
					  variant={'caption'}
					  fontWeight={700}
						fontSize={'1em'}
					  sx={{ color: 'common.black' }}
					>
					  {item.label}
					</Typography>
				</Box>
				))}
				<MuiLink component={Link} to="/pipy/releases">Previous version</MuiLink>
      </Box>
			{platform.indexOf("windows")>=0
			?<Typography color={'text.secondary'}>Windows platform need <MuiLink component={Link} to="https://docs.microsoft.com/en-us/windows/wsl/install" target="_blank">install wsl2</MuiLink></Typography>
      :null}
    </Box>
  );
};

Versions.propTypes = {
  currentData: PropTypes.object,
	platform: PropTypes.string,
};

export default Versions;
